<template>
  <div>
    <b-card class="prof-item">
        <div class="d-flex flex-nowrap justify-content-between">
          <router-link :to="`/profession/${currentProfession.id}`">
            <h5>{{currentProfession.title}}</h5>
          </router-link>
          <div class="d-flex flex-nowrap" v-if="((hasRole('curator') && currentProfession.organizationId === currUser.organizationId) || hasRole('admin')) && !isStudentPage">
            <div @click="onEdit" class="icons-main-color fas fa-edit mr-2" style="cursor: pointer;"></div>
            <div @click="onDelete" class="fas fa-times text-danger text-center" style="cursor: pointer;"></div>
          </div>
          <div v-else-if="!(hasRole('student'))"></div>
          <div class="d-flex flex-wrap" v-else-if="marked">
            <div @click="unmarkProfession" class="fas fa-bookmark mr-2" style="cursor: pointer;"></div>
          </div>
          <div class="d-flex flex-wrap" v-else>
            <div @click="markProfession" class="far fa-bookmark mr-2" style="cursor: pointer;"></div>
          </div>
        </div>
        <a class="prof-organization" :href="currentProfession.organization.siteUrl ? currentProfession.organization.siteUrl: '/page_not_exist'" target="_blank">{{currentProfession.organization.title}}</a>
        <div class="prof-description overflow-hidden" style="max-height: 100px">{{ currentProfession.data.description }}</div>
        <div class="text-right" v-if="hasRole('curator') || hasRole('admin')">
          <router-link :to="{path:`/administration/recommendation/professions-interested`, query: {orgId: currentProfession.organization.id, profId: currentProfession.id}}">
            Список заинтересованных
          </router-link>
        </div>
        
    </b-card>
  
  </div>
</template>
    
  <script>
  import EditProfessionModal from '@/components/admin/modals/recommendations/EditProfessionModal.vue'
  import DeleteModal from '@/components/ui/modals/DeleteModal.vue'
  import RecommendationAPI from '@/api/recommendation'
  import { mapGetters } from 'vuex'

  export default {
    name: 'Professions',
    components: {
      EditProfessionModal,
      DeleteModal
    },
    props: {
        currentProfession: {
            type: Object,
            default: {}
        },
        isStudentPage: {
          type: Boolean,
          default: false
        },
        isMarked: {
          type: Boolean,
          default: false
        }
    },
    data() {
      return { 
        editData: null,
        marked: this.isMarked
      }
    },
    computed: {
      ...mapGetters({
        currUser: 'currentUser/getCurrentUser',
        hasRole: 'currentUser/hasRole',
        fetchProfessionsList: 'profession/fetchProfessions'
      })
    },
    methods: {
      async markProfession() {
        await RecommendationAPI.markProfession(this.currentProfession.id);
        this.$emit('professionChanged');
        this.marked = true;
         //вызвать до marked
      },
      async unmarkProfession() {
        await RecommendationAPI.unmarkProfession(this.currentProfession.id);
        this.$emit('professionChanged');
        this.marked = false;
      },
      onEdit() {
        this.$emit('edit', this.currentProfession)
      },
      async onDelete() {
        this.$emit('delete', this.currentProfession);
      }
    }
  }
  </script>
    
  <style scoped>
    .ag-grid-olympics-list {
      height: calc(100vh - 230px);
    }
    .prof-organization {
      color:gray;
    }
  
    .icons-main-color {
      color: #017ac3;
    }
  
    .prof-item {
      margin-bottom: 1rem;
    }
    .prof-item:first-of-type {
      margin-top: 0;
      margin-bottom: 5px;
    }
    .prof-item:last-of-type {
      margin-bottom: 5px;
    }
  </style>
    